/* <jevi-card-slider>: cards wrap in a grid on desktop and become a one-per-view slider below 750px
   (arrows + progress bar), as the source's "gms" swiper. Markup: [data-track] with the cards, [data-prev]/[data-next], [data-fill]. */
if (!customElements.get('jevi-card-slider')) {
  class JeviCardSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.items = [...this.track.children];
      this.fill = this.querySelector('[data-fill]');
      this.i = 0;
      this.mq = window.matchMedia('(max-width: 749px)');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.i - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.i + 1));
      this.mq.addEventListener('change', () => this.update());
      window.addEventListener('resize', () => this.update(), { passive: true });
      let x0 = null;
      this.track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.go(this.i + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
      this.update();
    }
    go(n) {
      const len = this.items.length;
      this.i = ((n % len) + len) % len;
      this.update();
    }
    update() {
      const n = this.items.length;
      if (!n) return;
      if (this.mq.matches) {
        const cs = getComputedStyle(this.track);
        const gap = parseFloat(cs.columnGap || cs.gap) || 12;
        const w = this.items[0].getBoundingClientRect().width;
        this.track.style.transform = `translateX(${-this.i * (w + gap)}px)`;
      } else {
        this.track.style.transform = '';
      }
      if (this.fill) this.fill.style.transform = `scaleX(${(this.i + 1) / n})`;
    }
  }
  customElements.define('jevi-card-slider', JeviCardSlider);
}
